<template>
    <div>
        <Loading :isLoading="isLoading" />
        <CRow style="height:100% !important" >
            <CCol col="12" xl="12" style="height:100% !important">
                <transition name="slide">
                    <CCard style="height:100% !important">
                        <CCardBody height="100%">
                            <div class="row d-flex justify-content-end mr-0 mb-3">
                                <div class="col-auto pr-0">
                                    <CButton color="success" to="/charges/add" v-if="isAuth && publicarCarga">
                                        <CIcon :content="addIcon" /> {{ $t('button.create') }} Carga
                                    </CButton>
                                    <CButton color="success" @click="showDetail = true" v-else>
                                        <CIcon :content="addIcon" /> {{ $t('button.create') }} Carga
                                    </CButton>
                                </div>
                            </div>
                            <CRow>
                                <div class="col-sm-2 offset-sm-2">
                                    <CSelect 
                                        :placeholder="$t('typeVehicles.placeholder')" 
                                        :label="$t('typeVehicles.title')" 
                                        :options="typeVehicles"
                                        :value.sync="field.type_vehicle_id"
                                        :plain="true"
                                    ></CSelect>
                                </div>
                                <div class="col-sm-2">
                                    <CSelect 
                                        :placeholder="$t('states.origin')" 
                                        :label="$t('states.origin')" 
                                        :options="states"
                                        :value.sync="field.state_id"
                                        :plain="true"
                                    ></CSelect>
                                </div>
                                <div class="col-sm-2">
                                    <CSelect 
                                        :placeholder="$t('type.placeholder')" 
                                        :label="$t('type.title')" 
                                        :options="types"
                                        :value.sync="field.type_id"
                                        :plain="true"
                                    ></CSelect>
                                </div>
                                <div class="col-sm-1">
                                    <CButton color="warning" @click="onClean" class="m-2">
                                        <CIcon :content="deleteIcon" /> {{ $t('button.clean') }}
                                    </CButton>
                                </div>
                                <div class="col-sm-1">
                                    <CButton color="success" @click="onFilter" class="m-2">
                                        <CIcon :content="btnSearch" /> {{ $t('button.filter') }}
                                    </CButton>
                                </div>
                                <div class="col-sm-1 pt-2 ml-2">
                                    <CIcon :content="iconDiamond" size="2xl"/>
                                    <label class="ml-2">{{getRandomInt}}</label>
                                </div>
                            </CRow>
                            <div v-infinite-scroll="loadMore" 
                                infinite-scroll-disabled="busy" 
                                infinite-scroll-distance="13"
                            >
                                <CRow v-for="item of data" :key="item.id">
                                    <div class="col-sm-6 offset-sm-3">
                                        <ChargeItem 
                                            :item="item" 
                                            @onShowItem="onShowItem" 
                                        />
                                    </div>
                                </CRow>
                            </div>
                        </CCardBody>  
                    </CCard>
                </transition>
            </CCol>
        </CRow>
        <CModal
            color="warning"
            :show.sync="showDetail"
            :title="$t('charges.detail')"
        >
            <div v-if='!isAuth'>
                {{messageLogin}}
            </div>
            <div v-else-if="!canViewDetail">
                <CRow>
                    <div class="col-sm-12">
                        {{messagePremium}}
                    </div>
                </CRow>
                <CRow>
                    <div class="col-sm-6 offset-sm-3 mt-5">
                        <a :href="urlWhatsappPremium" class="btn-whatsapp" target="_blank">
                            <CIcon :content="iconChat" size="3xl"/> {{ $t('button.whatsapp') }} 
                        </a>
                    </div>
                </CRow>
            </div>
            <div v-else>
                <CRow>
                    <div class="col-sm-2">
                        <label class="label-detail">
                            Folio:
                        </label>
                    </div>
                    <div class="col-sm-10">
                        <label class="label-detail" v-if="item != null">
                            {{item.id}}
                        </label>
                    </div>
                </CRow>
                <CRow style="margin: 40px !important">
                    <div class="col-sm-12" style="text-align: center;">
                        <label class="label-detail" v-if="item != null">
                            {{item.name_vehicle}}
                        </label>
                    </div>
                </CRow>
                <CRow>
                    <div class="col-sm-2">
                        <label class="label-detail">
                            De:
                        </label>
                    </div>
                    <div class="col-sm-5">
                        <label class="label-detail" v-if="item != null">
                            {{originStateName}}
                        </label>
                    </div>
                    <div class="col-sm-5">
                        <label class="label-detail" v-if="item != null">
                            {{item.originMunicipality}}
                        </label>
                    </div>
                </CRow>
                <CRow>
                    <div class="col-sm-2">
                        <label class="label-detail">
                            A:
                        </label>
                    </div>
                    <div class="col-sm-5">
                        <label class="label-detail" v-if="item != null">
                            {{destinationStateName}}
                        </label>
                    </div>
                    <div class="col-sm-5">
                        <label class="label-detail" v-if="item != null">
                            {{item.destinationMunicipality}}
                        </label>
                    </div>
                </CRow>
                <CRow>
                    <div class="col-sm-12">
                        <label class="label-detail">
                            Comentarios:
                        </label>
                    </div>
                    <div class="col-sm-12">
                        <label class="label-detail" v-if="item != null">
                            {{item.comments}}
                        </label>
                    </div>
                </CRow>
                <CRow>
                    <div class="col-sm-6 offset-sm-3">
                        <a :href="urlWhatsapp" class="btn-whatsapp" target="_blank" @click.prevent="onContactWhatsapp">
                            <CIcon :content="iconChat" size="3xl"/> {{ $t('button.whatsapp') }} 
                        </a>
                    </div>
                </CRow>
            </div>
            <template #footer>
                <CButton @click="showDetail = false" color="warning">Cerrar</CButton>
            </template>
        </CModal>
        <CModal
            color="warning"
            :show.sync="showPremiumContact"
            :title="$t('charges.detail')"
        >
            <CRow>
                <div class="col-sm-12">
                    {{messagePremium}}
                </div>
            </CRow>
            <CRow>
                <div class="col-sm-6 offset-sm-3 mt-5">
                    <a :href="urlWhatsappPremium" class="btn-whatsapp" target="_blank">
                        <CIcon :content="iconChat" size="3xl"/> {{ $t('button.whatsapp') }} 
                    </a>
                </div>
            </CRow>
            <template #footer>
                <CButton @click="showPremiumContact = false" color="warning">Cerrar</CButton>
            </template>
        </CModal>
    </div>
</template>

<script>
import axios from 'axios'
import store from '../../store'
import catalog from '../../hooks/catalogs';
import ChargeItem from "./components/Item.vue";
import Loading from "../../components/Loading.vue";
import { canOpenDetail } from '../../utils/premiumAccess';
import { cilPlus, cilSearch, cilTrash, cilChatBubble, cilDiamond } from '@coreui/icons';

export default {
    name: 'Charges',
    mixins: [catalog],
    components: {
        Loading,
        ChargeItem,
    },
    data() {
        return {
            page: 1,
            item: {},
            data: [],
            states: [],
            isAuth: false,
            isPremium: false,
            publicarCarga: false,
            types: [
                {
                    value: "1",
                    label: "Cargas premium",
                }
            ],
            busy: false,
            lastPage: 1,
            field: {
                type_id: '',
                state_id: '',
                type_vehicle_id: '',
            },
            isLoading: true,
            addIcon: cilPlus,
            typeVehicles: [],
            showDetail: false,
            showPremiumContact: false,
            btnSearch: cilSearch,
            deleteIcon: cilTrash,
            iconChat: cilChatBubble,
            iconDiamond: cilDiamond,
        }
    },
    computed: {
        messageLogin() {
            if (store.state.configuration != null 
                && store.state.configuration.configuration != null) {
                return store.state.configuration.configuration.registrate;
            } else {
                return "";
            }
        },
        messagePremium() {
            if (store.state.configuration != null) {
                return store.state.configuration.configuration.text_not_show_premium_trip;
            } else {
                return "aoeu";
            }
        },
        originStateName() {
            if (this.item && this.item.origin_state) {
                return this.item.origin_state.name;
            } else {
                return "";
            }
        },
        destinationStateName() {
            if (this.item && this.item.destination_state) {
                return this.item.destination_state.name;
            } else {
                return "";
            }
        },
        urlWhatsapp() {
            return "https://wa.me/"+this.item.phone;
        },
        urlWhatsappPremium() {
            if (store.state.configuration != null 
                && store.state.configuration.configuration != null) {
                return "https://wa.me/"+store.state.configuration.configuration.text_not_show_premium_trip_phone;
            } else {
                return "";
            }
        },
        getRandomInt() {
            var min = 2000; 
            var max = 3000;
            min = Math.ceil(min);
            max = Math.floor(max);
            return Math.floor(Math.random() * (max - min + 1) + min);
        },
        canViewDetail() {
            return canOpenDetail(this.isPremium, store.state.user);
        },
    },
    methods: {
        onShowItem(item) {  
            this.item = item;
            this.showDetail = true;
        },
        onContactWhatsapp() {
            if (!this.isPremium) {
                this.showPremiumContact = true;
                return;
            }

            window.open(this.urlWhatsapp, '_blank');
        },
        onClean() {  
            this.field = {
                type_id: '',
                state_id: '',
                type_vehicle_id: '',
            };

            this.page = 1;
            this.data = [];
            this.lastPage = 1;
            this.isLoading = true;
            this.onGetRecords();
        },
        onFilter() {  
            this.page = 1;
            this.data = [];
            this.lastPage = 1;
            this.isLoading = true;
            this.onGetRecords();
        },
        loadMore() {  
            let self = this;

            console.log("self.page");
            console.log(self.page);
            console.log("self.lastPage");
            console.log(self.lastPage);

            if (self.lastPage > self.page) {
                self.page++;
                self.busy = true;
                self.isLoading = true;
                self.onGetRecords();
            }
        },
        onGetRecords() {  
            let self = this;
            const token = localStorage.getItem('token', null);

            var url = `charges?page=${this.page}&vehicleId=${this.field.type_vehicle_id}&stateId=${this.field.state_id}`;

            if (self.field.type_id == "1") {
                url = url + `&isPremium=1`;
            }

            axios.get(url, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    }
                })
                .then(response => {
                    self.lastPage = response.data.last_page;
                    self.data.push(...response.data.data);
                    self.busy = false;
                    self.isLoading = false;
                }).catch(error => {
                    if (error.response.status === 401) {
                        self.$router.push({ path: '/login' });
                    } else {
                        self.$toast.error(error.response.data.message);
                    }
                });
        },
        getConfiguration() {
            console.log("canfi");
            axios.post('/configuration', {
                version: 0,
            }).then(response => {
                store.dispatch('setConfiguration', response.data);
            }).catch(error => {
                this.$toast.error(error.response.data.message);
            });
        }
    },
    mounted() {
        let self = this;

        self.isPremium = (store.state.user != null && store.state.user.ver_cargas) ? store.state.user.ver_cargas : false;
        self.publicarCarga = (store.state.user != null && store.state.user.publicar_cargas) ? store.state.user.publicar_cargas : false;
        self.isAuth = localStorage.getItem('login', false);
        self.getConfiguration();

        axios.get(`type-vehicle`)
            .then(response => {
                response.data.forEach(function(record){
                    self.typeVehicles.push({
                        value: record.id,
                        label: record.name,
                    });
                });
            }).catch(error => {
                if (error.response.status === 401) {
                    self.$router.push({ path: '/login' });
                } else {
                    self.$toast.error(error.response.data.message);
                }
            });

        axios.get(`states`)
            .then(response => {
                response.data.forEach(function(record){
                    self.states.push({
                        value: record.id,
                        label: record.name,
                    });
                });
            }).catch(error => {
                if (error.response.status === 401) {
                    self.$router.push({ path: '/login' });
                } else {
                    self.$toast.error(error.response.data.message);
                }
            });

        self.onGetRecords();
    }
}
</script>

<style>
    .label {
        color: white;
        font-size: 20px;
    }
    .btn-detail {
        height: 50px; 
        padding: 10px;
        font-size: 20px;
        cursor: pointer;
        font-weight: bold;
        text-align: center; 
        border-radius: 25px; 
        background-color: grey; 
        color: white !important; 
        border: 2px solid white; 
    }
    .label-detail {
        color: #000000;
        font-size: 20px;
    }
    .btn-whatsapp {
        height: 50px; 
        padding: 20px;
        font-size: 20px;
        cursor: pointer;
        font-weight: bold;
        text-align: center; 
        border-radius: 25px; 
        background-color: grey; 
        color: white !important; 
        border: 2px solid white; 
    }
</style>
